import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {WarningModalService} from 'src/app/services/warning-modal/warning-modal.service';
import {PermissionsService} from "../../services/permissions/permissions.service";

@Component({
  selector: 'app-share-track-report-expiry-modal',
  templateUrl: './share-track-expiry-report-modal.component.pug',
  styleUrls: ['./share-track-expiry-report-modal.component.scss'],
  standalone: false
})
export class ShareTrackExpiryReportModalComponent implements OnInit {
  @ViewChild('candidateField') candidateText: any = ''
  @ViewChild('refereeField') refereeText: any = ''
  @Output() updateParent: EventEmitter<any> = new EventEmitter()

  @Output() saveClick: EventEmitter<any> = new EventEmitter();
  expiryPopupTitle = $localize`Share and Track expiry time`;
  expiryPopupDescription = $localize`Set the expiry time for shared reference reports.`;
  expiryText = $localize`Shared reports will expire after`;
  expiryValidationText = $localize`Please enter a number between 1 and 90.`;
  placeholderText = $localize`Enter a number from 1 to 90`;
  org_details: any
  expiryTime: any;
  userAllowed = false;
  expiryUnit: any;
  isValid = true;
  expiryOption = [
    {'key': 'days', 'value': $localize`days`},
    {'key': 'hours', 'value': $localize`hours`},
    {'key': 'minutes', 'value': $localize`minutes`}
  ]
  errors = [
    {name: 'inValidNumbers', msg: this.expiryValidationText, enabled: false},
  ];


  constructor(
    public _bsModalRef: BsModalRef,
    public modal: WarningModalService,
    public permissions: PermissionsService
  ) {
  }

  ngOnInit(): void {
    if (this.permissions.hasUserOrgPermission('can_set_reference_settings')) {
      this.userAllowed = true;
    }

  }


  clickSave() {
    this.saveClick.emit({'token_expiry': this.expiryTime, 'token_value': this.expiryUnit});
    this._bsModalRef.hide();
  }

  setError(name: string, enabled: boolean) {
    const errorToUpdate = this.errors.find(o => o.name === name);
    if (errorToUpdate) {
      errorToUpdate.enabled = enabled;
      this.errors = [...this.errors];
      this.isValid = false;
    }
  }

  resetErrors() {
    this.errors.forEach(x => x.enabled = false)
    this.isValid = true;
  }

  cancel() {
    this._bsModalRef.hide();
  }

  validateExpiryTime(value) {
    if (value > 90 || (value < 1 && this.expiryTime)) {
      this.setError('inValidNumbers', true);
    } else {
      this.resetErrors()
    }
  }

  selectedExpiryChange(expiry: any): void {
    this.expiryUnit = expiry.value;
  }

}
